import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  \n  font-style: normal;\n  font-weight: 800;\n  font-size: 14px;\n  line-height: 140%;\n  display: flex;\n  align-items: center;\n  color: #000;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { useMatchBreakpoints } from "@pancakeswap/uikit";
import styled from "styled-components";
import { Flex } from "../Box";
import { StyledFooter, StyledSocialLinks, StyledToolsContainer } from "./styles";
var ListTitle = styled.div.withConfig({
    componentId: "sc-115dc82b-0"
})(_templateObject());
var MenuItem = function(_param) {
    var isDark = _param.isDark, toggleTheme = _param.toggleTheme, currentLang = _param.currentLang, langs = _param.langs, setLang = _param.setLang, props = _object_without_properties(_param, [
        "isDark",
        "toggleTheme",
        "currentLang",
        "langs",
        "setLang"
    ]);
    var isMobile = useMatchBreakpoints().isMobile;
    var ref = useState("top-left"), position1 = ref[0], setPosition1 = ref[1];
    useEffect(function() {
        if (isMobile) {
            setPosition1("top-right");
        } else {
            setPosition1("top-left");
        }
    }, [
        isMobile
    ]);
    return /*#__PURE__*/ _jsx(StyledFooter, _object_spread_props(_object_spread({
        p: isMobile ? [
            "25px 16px",
            null
        ] : [
            "25px 16px 10px 16px",
            null
        ]
    }, props), {
        justifyContent: "center",
        children: /*#__PURE__*/ _jsxs(Flex, {
            flexDirection: "column",
            justifyContent: "center",
            width: [
                "100%",
                null,
                "1200px;"
            ],
            children: [
                /*#__PURE__*/ _jsx(StyledSocialLinks, {
                    order: isMobile ? [
                        0
                    ] : [
                        2
                    ],
                    pb: [
                        "42px",
                        null,
                        "32px"
                    ],
                    mb: [
                        "0",
                        null,
                        "32px"
                    ]
                }),
                /*#__PURE__*/ _jsx(StyledToolsContainer, {
                    order: isMobile ? [
                        0
                    ] : [
                        1,
                        null,
                        3
                    ],
                    flexDirection: [
                        "column",
                        null,
                        "row"
                    ],
                    justifyContent: "center",
                    alignItems: isMobile ? "center" : "none",
                    width: "100%",
                    style: {
                        paddingBottom: 0,
                        marginBottom: 0
                    },
                    children: /*#__PURE__*/ _jsx(Flex, {
                        style: {
                            marginTop: "-50px"
                        },
                        alignItems: "center",
                        children: /*#__PURE__*/ _jsx(ListTitle, {
                            color: "light",
                            children: "\xa9 2024 Coinfair. All Rights Reserved."
                        })
                    })
                })
            ]
        })
    }));
};
export default MenuItem;
